import React, { useState } from 'react';
import { Bell, X, Check } from 'lucide-react';
import { useNotifications } from '../contexts/NotificationContext';
export function NotificationCenter() {
  const {
    notifications,
    unreadCount,
    markAsRead,
    clearAll
  } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);
  return <div className="relative" data-id="element-217" data-mp="3frmkruuiy7fe">
      <button onClick={() => setIsOpen(!isOpen)} className="relative p-2 rounded-xl hover:bg-slate-100 text-slate-500 transition-colors" data-id="element-218" data-mp="3fqjrjg9qbswb">
        <Bell className="h-5 w-5" data-id="element-219" data-mp="3pih34o4ngmvk" />
        {unreadCount > 0 && <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" data-id="element-220" data-mp="7c2r4upxymzt"></span>}
      </button>

      {isOpen && <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} data-id="element-221" data-mp="2avk4xvmhru7"></div>
          <div className="absolute right-0 mt-2 w-80 sm:w-96 bg-white rounded-2xl shadow-xl border border-slate-100 z-50 overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-222" data-mp="244cqzzbxionw">
            <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50" data-id="element-223" data-mp="260st0b84claw">
              <h3 className="font-bold text-seform-navy" data-id="element-224" data-mp="2aznmc73pps99">Notifiche</h3>
              {notifications.length > 0 && <button onClick={clearAll} className="text-xs text-slate-500 hover:text-seform-orange transition-colors" data-id="element-225" data-mp="2krjktj9pnke0">
                  Cancella tutto
                </button>}
            </div>

            <div className="max-h-[400px] overflow-y-auto custom-scrollbar" data-id="element-226" data-mp="2tukm96nmsnbc">
              {notifications.length === 0 ? <div className="p-8 text-center text-slate-400" data-id="element-227" data-mp="33qdy0ntj0cs2">
                  <Bell className="h-8 w-8 mx-auto mb-2 opacity-20" data-id="element-228" data-mp="33pw1rr6v5yk5" />
                  <p className="text-sm" data-id="element-229" data-mp="14ev0d5doaqxp">Nessuna notifica</p>
                </div> : <div className="divide-y divide-slate-50" data-id="element-230" data-mp="19dfow7jkbm6b">
                  {notifications.map(notif => <div key={notif.id} className={`p-4 hover:bg-slate-50 transition-colors ${!notif.read ? 'bg-blue-50/30' : ''}`} data-id="element-231" data-mp="11cgp94bts5iz">
                      <div className="flex justify-between items-start gap-3" data-id="element-232" data-mp="1bbph9rn4ra2p">
                        <div className="flex-1" data-id="element-233" data-mp="16a02q20p8e9v">
                          <div className="flex items-center gap-2 mb-1" data-id="element-234" data-mp="16de53a9d4nhb">
                            {notif.type === 'urgent' && <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-235" data-mp="1fchsgqfkbp1m"></span>}
                            <h4 className={`text-sm font-semibold ${!notif.read ? 'text-seform-navy' : 'text-slate-600'}`} data-id="element-236" data-mp="1tzax91rghcfk">
                              {notif.title}
                            </h4>
                          </div>
                          <p className="text-xs text-slate-500 mb-2" data-id="element-237" data-mp="1z0qjuy9a7r02">
                            {notif.message}
                          </p>
                          <span className="text-[10px] text-slate-400" data-id="element-238" data-mp="2hlwndarnqyjn">
                            {notif.date.toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                          </span>
                        </div>
                        {!notif.read && <button onClick={() => markAsRead(notif.id)} className="text-slate-400 hover:text-seform-orange p-1" title="Segna come letto" data-id="element-239" data-mp="1ywq5fpyouayw">
                            <Check className="h-4 w-4" data-id="element-240" data-mp="1txx1ao5ajwbe" />
                          </button>}
                      </div>
                    </div>)}
                </div>}
            </div>
          </div>
        </>}
    </div>;
}